import React from "react";
import StyledDataGrid from "../../../components/StyledDataGrid";
import { GridColDef } from "@material-ui/data-grid";

const TechnologyChannelTable = ({ technology }) => {
  if (!technology) {
    return null;
  }

  const columnsSettings: GridColDef[] = [
    {
      field: 'channelNumber',
      headerName: 'Channel',
      editable: false,
      sortable: false,
      minWidth: 200,
      disableColumnMenu: true,
    },
    {
      field: 'downlinkCF',
      headerName: 'Central Frequency',
      editable: false,
      sortable: false,
      minWidth: 200,
      disableColumnMenu: true,
    },
    {
      field: 'bandwidth',
      headerName: 'Bandwidth',
      editable: false,
      sortable: false,
      minWidth: 200,
      disableColumnMenu: true,
    },
    {
      field: 'EIRP',
      headerName: 'EIRP',
      editable: false,
      sortable: false,
      minWidth: 200,
      disableColumnMenu: true,
    },
  ];

  const tableData = (technology.channels || []).map((channel) => {
    return {
      bandwidth: technology.bandwidth,
      ...channel,
    }
  })

  return (
    <StyledDataGrid
      checkboxSelection={false}
      columns={columnsSettings}
      disableColumnSelector
      rows={tableData}
      noPagination
      hideHorizontalScroll
      density="compact"
    />
  )
}

export default TechnologyChannelTable;